import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { SharedModule } from '../shared/shared.module'
import { FormContactComponent } from './form-contact/form-contact.component'
import { i18nResolver } from 'app/_resolvers/i18n.resolver'

// Routing
const contactRoutes: Routes = [
    {
        path: ':language/:affiliate',
        component: FormContactComponent,
        children: [],
        resolve: {
            language: i18nResolver,
        },
    },
]

@NgModule({
    imports: [SharedModule, RouterModule.forChild(contactRoutes), FormContactComponent],
    providers: [],
})
export class ContactModule {}
